import React from "react";
import { cn } from "../../lib/utils";

export function EmptyState({ icon: Icon, title, description, action, className }) {
  return (
    <div className={cn("valhalla-card px-5 py-10 text-center sm:p-12", className)}>
      {Icon ? (
        <Icon className="mx-auto mb-4 h-10 w-10 text-[#9CA3AF] sm:h-12 sm:w-12" />
      ) : null}
      {title ? (
        <p className="font-semibold text-[#F3F4F6]">{title}</p>
      ) : null}
      {description ? (
        <p className={cn("mx-auto max-w-md text-sm leading-6 text-[#9CA3AF]", title && "mt-1")}>
          {description}
        </p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
